import { z } from "zod";

/** Machine-readable error codes returned by the API. */
export const ApiErrorCodeSchema = z.enum([
  "BAD_REQUEST",
  "UNAUTHENTICATED",
  "FORBIDDEN",
  /** Signed in, but the session has no workspace chosen (or lost access to it). */
  "WORKSPACE_REQUIRED",
  /** The workspace enforces company SSO and this session signed in another way. */
  "SSO_REQUIRED",
  "CONFLICT",
  "NOT_CONFIGURED",
  "VALIDATION_ERROR",
  "NOT_FOUND",
  "PAYLOAD_TOO_LARGE",
  "RATE_LIMITED",
  "UPSTREAM_ERROR",
  "TIMEOUT",
  "INTERNAL_ERROR",
]);
export type ApiErrorCode = z.infer<typeof ApiErrorCodeSchema>;

/** Standard error envelope: every non-2xx response from the API has this shape. */
export const ApiErrorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;

/** A single field-level validation issue (subset of Zod's issue shape). */
export const ValidationIssueSchema = z.object({
  path: z.array(z.union([z.string(), z.number()])),
  message: z.string(),
  code: z.string().optional(),
});
export type ValidationIssue = z.infer<typeof ValidationIssueSchema>;
